<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="EditInsight"
    title="Edit Insight"
    submit-name="Save changes"
    full-height
    disable-tabindex
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <lm-logo v-if="!currentInsight" />
    <template v-else>
      <div class="flex">
        <select
          v-model="type"
          class="TypeSelect max-w-xxs truncate"
          :class="`bg-insight-${type.color}`"
        >
          <option
            v-for="t in insightTypes"
            :key="t.key"
            :value="t"
            :class="`bg-insight-${t.color}`"
            >{{ t.label }}</option
          >
        </select>
        <lm-axis-select
          ref="axisSelect"
          class="ml-4 mb0-important"
          :selected-axis="axis"
        />
      </div>
      <lm-input
        ref="inputTitle"
        class="Title"
        label="Title"
        :maxlength="200"
        @submit="submitFromInput"
      />
      <lm-editor
        ref="inputEditor"
        v-model="text"
        :label="cText"
        :optional="false"
        @submit="submitFromInput"
      />
      <related-topics ref="relatedTopics" :temp-topics="tempTopics" />
    </template>
  </form-modal>
</template>

<script>
import LmLogo from '@/components/ui/LmLogo'
import {mapGetters} from 'vuex'
import {imgInHTMLResize} from './Topic/resizeImagesInHTML'
import {Events, Modal} from '@/lib/definitions'
import FormModal from '@/components/modals/FormModal'
import LmAxisSelect from '@/components/form/LmAxisSelect'
import LmInput from '@/components/form/LmInput.vue'
import FormHelper from '@/components/form/formHelper'
import LmEditor from '@/components/form/LmEditor'
import RelatedTopics from '@/components/landscape/common/RelatedTopics'

export default {
  name: 'ModalEditInsight',
  components: {
    LmLogo,
    RelatedTopics,
    LmEditor,
    FormModal,
    LmInput,
    LmAxisSelect
  },
  data() {
    return {
      Events,
      Modal,
      modalName: Modal.EDIT_INSIGHT,
      modalRef: null,
      inputs: null,
      text: '',
      type: {},
      axis: null
    }
  },
  computed: {
    ...mapGetters({
      currentInsight: 'insights/current',
      tempTopics: 'insights/helpers/tempTopics',
      insightTypes: 'insights/settings/types',
      defaultInsightType: 'insights/settings/defaultType',
      getInsightType: 'insights/settings/getInsightType'
    }),
    ...mapGetters(['getAxisByID', 'currentLandscape']),
    cText() {
      // Berry exception
      return this.currentLandscape?._id === '619e736c67d30bc929443fd2'
        ? 'Why is this interesting and what is your future vision?'
        : 'Text'
    }
  },
  watch: {
    // Insight is not loaded if editing from summary
    currentInsight() {
      if (this.$route.query.modal === Modal.EDIT_INSIGHT) {
        this.$nextTick(() => {
          this.setInputData()
        })
      }
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
  },
  methods: {
    setInputData() {
      this.inputs = [
        this.$refs.inputTitle,
        this.$refs.inputEditor,
        this.$refs.relatedTopics
      ]
      this.$refs.inputTitle.data = this.currentInsight.title
      this.text = this.currentInsight.text
      this.type =
        this.getInsightType(this.currentInsight) || this.defaultInsightType
      this.axis = this.getAxisByID(this.currentInsight.axisId)
    },
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      if (FormHelper.validate(this.inputs)) {
        imgInHTMLResize(this.text).then(resizedImgsText => {
          // Call API
          let payload = {
            id: this.currentInsight._id,
            title: this.$refs.inputTitle.data,
            text: resizedImgsText,
            type: this.type.key,
            topics: this.tempTopics,
            mentions: FormHelper.getEditorMentions(),
            axisId: this.$refs.axisSelect.data
          }
          this.$store
            .dispatch('insights/edit', payload)
            .then(() => this.modalRef.submitSuccess())
            .catch(error => this.modalRef.submitFails(error))
        })
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed() {
      if (this.currentInsight) {
        FormHelper.reset(this.inputs)
        FormHelper.clearErrors(this.inputs)
      }
      this.$store.commit('insights/helpers/removeTempTopics')
    }
  }
}
</script>

<!-- TODO merge with ModalNewInsight -->
<style>
.EditInsight {
  .LmEditor {
    margin-top: 40px;
  }
  select {
    margin-bottom: 20px;
  }
  .TypeSelect {
    height: 24px;
    padding: 0 8px;
    color: white;
    outline: none;
    border: none;
    font-size: 12px;
    letter-spacing: 0.5px;
    option {
      padding: 8px;
      margin: 8px;
      height: 20px;
      background: white;
      color: black;
      font-size: 13px;
    }
  }
}
</style>
